import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'el',
  months: [
    'Ιανουαρίου',
    'Φεβρουαρίου',
    'Μαρτίου',
    'Απριλίου',
    'Μαΐου',
    'Ιουνίου',
    'Ιουλίου',
    'Αυγούστου',
    'Σεπτεμβρίου',
    'Οκτωβρίου',
    'Νοεμβρίου',
    'Δεκεμβρίου',
  ],
  monthsShort: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαΐ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
  weekdays: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
  weekdaysMin: ['Κ', 'Δ', 'Τ', 'Τ', 'Π', 'Π', 'Σ'],
  weekdaysShort: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': '[HH:mm ([GMT]Z)]',
    'LLL+to': '[D MMMM YYYY - HH:mm ([GMT]Z)]',
  },
  meridiem: { am: 'πμ', pm: 'μμ', AM: 'ΠΜ', PM: 'ΜΜ' },
  past: {
    y: { one: 'πριν από %s έτος', other: 'πριν από %s έτη' },
    M: { one: 'πριν από %s μήνα', other: 'πριν από %s μήνες' },
    w: { one: 'πριν από %s εβδ.', other: 'πριν από %s εβδ.' },
    d: { one: 'πριν από %s ημ.', other: 'πριν από %s ημ.' },
    h: { one: 'πριν από %s ώ.', other: 'πριν από %s ώ.' },
    m: { one: 'πριν από %s λεπ.', other: 'πριν από %s λεπ.' },
    s: { one: 'πριν από %s δευτ.', other: 'πριν από %s δευτ.' },
  },
  future: {
    y: { one: 'σε %s έτος', other: 'σε %s έτη' },
    M: { one: 'σε %s μήνα', other: 'σε %s μήνες' },
    w: { one: 'σε %s εβδ.', other: 'σε %s εβδ.' },
    d: { one: 'σε %s ημ.', other: 'σε %s ημ.' },
    h: { one: 'σε %s ώ.', other: 'σε %s ώ.' },
    m: { one: 'σε %s λεπ.', other: 'σε %s λεπ.' },
    s: { one: 'σε %s δευτ.', other: 'σε %s δευτ.' },
  },
  abbr: {
    y: { one: '%s έτ.', other: '%s έτ.' },
    M: { one: '%s μήν.', other: '%s μήν.' },
    w: { one: '%s εβδ.', other: '%s εβδ.' },
    d: { one: '%s ημέρα', other: '%s ημέρες' },
    h: { one: '%s ώ.', other: '%s ώ.' },
    m: { one: '%s λ.', other: '%s λ.' },
    s: { one: '%s δευτ.', other: '%s δευτ.' },
  },
  justNow: 'Μόλις τώρα',
  yesterday: 'Χθες',
  today: 'Σήμερα',
  tomorrow: 'Αύριο',
  weekStart: 1,
};
const localeName: LocaleName = 'el';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'πμ' : 'ΠΜ';
    } else {
      return isLowerCase ? 'μμ' : 'ΜΜ';
    }
  },
};
